/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_LandscapeInputs */

const en_val_landscape = /** @type {(inputs: Val_LandscapeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Landscape`)
};

const es_val_landscape = /** @type {(inputs: Val_LandscapeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paisaje`)
};

const fr_val_landscape = /** @type {(inputs: Val_LandscapeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paysage`)
};

const de_val_landscape = /** @type {(inputs: Val_LandscapeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Landschaft`)
};

const ja_val_landscape = /** @type {(inputs: Val_LandscapeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`風景`)
};

const zh_val_landscape = /** @type {(inputs: Val_LandscapeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`风景摄影`)
};

const ar_val_landscape = /** @type {(inputs: Val_LandscapeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصوير طبيعة`)
};

const id_val_landscape = /** @type {(inputs: Val_LandscapeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanskap`)
};

const it_val_landscape = /** @type {(inputs: Val_LandscapeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paesaggio`)
};

const ru_val_landscape = /** @type {(inputs: Val_LandscapeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пейзаж`)
};

const pt_val_landscape = /** @type {(inputs: Val_LandscapeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paisagem`)
};

const ko_val_landscape = /** @type {(inputs: Val_LandscapeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`풍경`)
};

/**
* | output |
* | --- |
* | "Landscape" |
*
* @param {Val_LandscapeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_landscape = /** @type {((inputs?: Val_LandscapeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_LandscapeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_landscape(inputs)
	if (locale === "es") return es_val_landscape(inputs)
	if (locale === "fr") return fr_val_landscape(inputs)
	if (locale === "de") return de_val_landscape(inputs)
	if (locale === "ja") return ja_val_landscape(inputs)
	if (locale === "zh") return zh_val_landscape(inputs)
	if (locale === "ar") return ar_val_landscape(inputs)
	if (locale === "id") return id_val_landscape(inputs)
	if (locale === "it") return it_val_landscape(inputs)
	if (locale === "ru") return ru_val_landscape(inputs)
	if (locale === "pt") return pt_val_landscape(inputs)
	return ko_val_landscape(inputs)
});